import EntityTableTemplate from "../../MyUI/EntityTableTemplate/EntityTableTemplate";
import { ticketsConfig } from "./tickets_conf";

export default function Tickets() {
  return <EntityTableTemplate config={ticketsConfig} />;
}
